<template>
    <div :style="{ width: `${maxWidth}px`}"
         class="sb_progress-bar_container">
        <div class="sb_progress-bar_back" />
        <div :style="{ width: `${progress}%`}"
             class="sb_progress-bar_front" />
    </div>
</template>

<script>
export default {
    name: 'progress-bar',
    props: {
        maxWidth: {
            default: 100,
            type: Number
        }
    },
    data() {
        return {
            progress: 0,
            running: false
        };
    },
    methods: {
        start(time) {
            if (this.running) return false;
            this.running = true;
            this.$anime({
                targets: this.$data,
                progress: [0, 100],
                duration: time,
                easing: 'linear',
                complete: () => {
                    this.$emit('done');
                    this.running = false;
                }
            });
        },
        reset() {
            this.progress = 0;
        }
    }
};
</script>

<style lang="scss" scoped>
.sb_progress-bar_container {
    position: relative;
    height: 4px;
    display: block;
    margin: 5px;
    width: 100px;
}
.sb_progress-bar_back {
    position: absolute;
    width: 100px;
    height: 4px;
    background: rgba($brand-white, 0.3);
}
.sb_progress-bar_front {
    position: absolute;
    height: 4px;
    background: rgba($brand-white, 1);
}
</style>
